export default __webpack_public_path__ + "static/media/dogNotHealthy.63909cc0.png";